import { InjectionToken } from '@angular/core';
import { AuthSession } from './auth-session';
import { LoginFlow } from './login-flow';

export const LOGIN_FLOW = new InjectionToken<LoginFlow>('LOGIN_FLOW');
export const AUTH_SESSION = new InjectionToken<AuthSession>('AUTH_SESSION');
